import { takeLeading } from "@redux-saga/core/effects";
import { AuthActionTypes } from "../types";
import { confirmUserSaga } from "./confirmUserSaga";
import { forgotPasswordSaga } from "./forgotPasswordSaga";
import { signInSaga } from "./signInSaga";
import { signUpSaga } from "./signUpSaga";
import { googleSignInRequest } from "./googleSignIn";
import { oauthFlowSaga } from "./oauthFlowSaga";

export default function* authSaga() {
    yield takeLeading(AuthActionTypes.SIGN_IN_REQUEST, signInSaga);
    yield takeLeading(AuthActionTypes.SIGN_UP_REQUEST, signUpSaga);
    yield takeLeading(AuthActionTypes.FORGOT_PASSWORD_REQUEST, forgotPasswordSaga);
    yield takeLeading(AuthActionTypes.GOOGLE_LOGIN_REQUEST, googleSignInRequest);
    yield takeLeading(AuthActionTypes.CONFIRM_USER_REQUEST, confirmUserSaga);
    yield takeLeading(AuthActionTypes.OATUH_FLOW_REQUEST, oauthFlowSaga);
}
